'use client';
import { useState } from 'react';
import { createClient } from '@/lib/supabase/client';

const H = "Rajdhani, sans-serif";
const B = "'Nunito Sans', sans-serif";

const JOBS = [
  { id: 1, title: 'Senior Maskiningeniør', location: 'Oslo', department: 'Ingeniør' },
  { id: 2, title: 'Programvareutvikler (Full Stack)', location: 'Bergen', department: 'Teknologi' },
  { id: 3, title: 'Salgssjef — Nordics', location: 'Oslo', department: 'Salg' },
  { id: 4, title: 'Teknisk Supportspesialist', location: 'Trondheim', department: 'Support' },
  { id: 5, title: 'Prosjektleder — Industriautomatisering', location: 'Stavanger', department: 'Prosjekt' },
];

export default function KarriereInteractive() {
  const supabase = createClient();
  const [modalJob, setModalJob] = useState<typeof JOBS[0] | null>(null);
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '', cv: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!modalJob) return;
    setSubmitting(true);
    try {
      await supabase.from('job_applications').insert({
        job_title: modalJob.title,
        applicant_name: form.name,
        applicant_email: form.email,
        applicant_phone: form.phone,
        message: form.message,
        cv_filename: form.cv,
      });
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  const closeModal = () => { setModalJob(null); setSubmitted(false); setForm({ name: '', email: '', phone: '', message: '', cv: '' }); };

  const inputStyle: React.CSSProperties = { width: '100%', background: '#111', border: '1px solid #2A2A2A', color: 'white', fontFamily: B, fontWeight: 300, fontSize: '0.85rem', padding: '10px 14px', outline: 'none', boxSizing: 'border-box' };
  const labelStyle: React.CSSProperties = { fontFamily: H, fontWeight: 600, fontSize: '0.6rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', display: 'block', marginBottom: '6px' };

  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', paddingTop: '52px' }}>
      {/* Hero */}
      <div style={{ borderBottom: '1px solid #1A1A1A', padding: '64px 0 48px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: '12px' }}>Bli en del av teamet</p>
          <h1 style={{ fontFamily: H, fontWeight: 700, fontSize: 'clamp(2rem, 5vw, 3.5rem)', letterSpacing: '0.06em', textTransform: 'uppercase', color: 'white', margin: '0 0 16px' }}>Karriere</h1>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '1rem', color: 'rgba(255,255,255,0.45)', maxWidth: '560px' }}>Vi ser etter talentfulle mennesker som vil være med å forme fremtidens industriteknologi. Se våre ledige stillinger nedenfor.</p>
        </div>
      </div>

      {/* Jobs */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ border: '1px solid #2A2A2A' }}>
          {JOBS.map((job, i) => (
            <div key={job.id} style={{ padding: '24px 28px', borderBottom: i < JOBS.length - 1 ? '1px solid #1A1A1A' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
              <div>
                <h3 style={{ fontFamily: H, fontWeight: 700, fontSize: '1.1rem', letterSpacing: '0.05em', textTransform: 'uppercase', color: 'white', margin: '0 0 8px' }}>{job.title}</h3>
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.8rem', color: 'rgba(255,255,255,0.45)' }}>📍 {job.location}</span>
                  <span style={{ fontFamily: H, fontWeight: 600, fontSize: '0.6rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', border: '1px solid #2A2A2A', padding: '3px 8px' }}>{job.department}</span>
                </div>
              </div>
              <button
                onClick={() => setModalJob(job)}
                style={{ background: 'white', color: '#0A0A0A', border: 'none', fontFamily: H, fontWeight: 700, fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '10px 24px', cursor: 'pointer' }}
              >Søk nå</button>
            </div>
          ))}
        </div>
      </div>

      {/* Application Modal */}
      {modalJob && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }} onClick={e => { if (e.target === e.currentTarget) closeModal(); }}>
          <div style={{ background: '#0F0F0F', border: '1px solid #2A2A2A', padding: '40px', maxWidth: '520px', width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
              <div>
                <h2 style={{ fontFamily: H, fontWeight: 700, fontSize: '1.3rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: 'white', margin: '0 0 4px' }}>Søk på stilling</h2>
                <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.85rem', color: 'rgba(255,255,255,0.4)', margin: 0 }}>{modalJob.title}</p>
              </div>
              <button onClick={closeModal} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', fontSize: '1.2rem' }}>✕</button>
            </div>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '32px 0' }}>
                <div style={{ fontFamily: H, fontWeight: 700, fontSize: '1.2rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: '#22c55e', marginBottom: '12px' }}>✓ Søknad mottatt!</div>
                <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>Vi vil kontakte deg innen 5 virkedager.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ display: 'grid', gap: '14px' }}>
                  <div><label style={labelStyle}>Fullt navn</label><input style={inputStyle} value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required /></div>
                  <div><label style={labelStyle}>E-post</label><input style={inputStyle} type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} required /></div>
                  <div><label style={labelStyle}>Telefon</label><input style={inputStyle} type="tel" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} placeholder="+47 000 00 000" /></div>
                  <div><label style={labelStyle}>Last opp CV (filnavn)</label><input style={inputStyle} value={form.cv} onChange={e => setForm(p => ({ ...p, cv: e.target.value }))} placeholder="cv-navn.pdf" /></div>
                  <div><label style={labelStyle}>Melding</label><textarea style={{ ...inputStyle, minHeight: '100px', resize: 'vertical' }} value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} placeholder="Fortell oss om deg selv..." /></div>
                </div>
                <button type="submit" style={{ background: 'white', color: '#0A0A0A', border: 'none', fontFamily: H, fontWeight: 700, fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '12px', cursor: 'pointer', width: '100%', marginTop: '20px' }} disabled={submitting}>
                  {submitting ? 'Sender...' : 'Send søknad'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
